import React from 'react';
import * as ReactDOMClient from 'react-dom/client';

import ImageUpload from './Common/ImageUpload.js';

const rctImageUpload = document.getElementById('rct-imageupload');

if (rctImageUpload !== null) {
	const rctImageUploadType = rctImageUpload.dataset.type ? rctImageUpload.dataset.type : '';
	ReactDOMClient.createRoot(rctImageUpload).render(<ImageUpload type={rctImageUploadType} />);
}